// extracted by css-extract-rspack-plugin
export default {"SurveySectionWrapper":"survey-section_SurveySectionWrapper__zSvlo","TooltipTrigger":"survey-section_TooltipTrigger__TRIzt","SelectOptions":"survey-section_SelectOptions__N189m"};